module.exports = __webpack_public_path__ + "static/failed.fbc231f4.svg";